import React, { useEffect, useRef, useState } from "react";
import string from "../constants/string";
import info from "../assets/info.png";
import PopupContent from "./PopupContent";
import RegistrationForm from "./Forms/RegistrationForm";
import { addToCart, getCart } from "../apiEndpoints";
import { isLoggedIn } from "../utils/auth";
import Swal from "sweetalert2";
import { AuthContext } from "../utils/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Register = () => {
  const [selectedItems, setSelectedItems] = useState({
    B: [],
    C: [],
    D: [],
    E: [],
    F: [],
  });
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentComponent, setCurrentComponent] = useState(null);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [apiStatus, setApiStatus] = useState({ success: false, message: "" });
  const [disableOtherOptions, setDisableOtherOptions] = useState(false);
  const [goClicked, setGoClicked] = useState(false); // New state

  const formRef = useRef(null);
  const [showLoginModal, setShowLoginModal] = useState(false); // Make sure this line exists!

  // 2. Action functions
  const handleBuyNowClick = () => {
    setShowLoginModal(true);
  };
  const handleChange = (event) => {
    setSelectedCategory(event.target.value);
    console.log(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const category = categories.find((cat) => cat.eventId === selectedCategory);
    if (category) {
      setCurrentComponent(category);
      setDisableOtherOptions(true); // Disable other radio buttons after "Go" button is clicked
      setGoClicked(true); // Set goClicked to true when the button is clicked
    }
  };

  useEffect(() => {
    if (currentComponent) {
      formRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [currentComponent]);

  const resetFormState = () => {
    setSelectedCategory("");
    setCurrentComponent(null);
    setLoading(false);
    setApiStatus({ success: false, message: "" });
    setDisableOtherOptions(false); // Re-enable radio buttons on reset
    setGoClicked(false); // Reset goClicked to false when the form is reset
  };

  const renderComponent = () => {
    if (currentComponent) {
      const { title, eventId, roles } = currentComponent;

      return (
        <div ref={formRef}>
          <RegistrationForm
            key={roles + (goClicked ? "active" : "inactive")}
            title={title}
            eventId={eventId}
            userRole={roles}
            setLoading={setLoading}
            loading={loading}
            setApiStatus={setApiStatus}
            apiStatus={apiStatus}
            onNext={resetFormState}
          />
        </div>
      );
    }
    return null;
  };

  const [popup, setPopup] = useState(false);
  const [popupContent, setPopupContent] = useState("");

  const handlePopup = (info) => {
    setPopupContent(info);
    setPopup(true);
  };
  const handleAddToCart = async (category, item) => {
    if (!isAuthenticated) {
      Swal.fire({
        icon: "warning",
        title: "Not Logged In",
        text:
          category === "A"
            ? "Additional Meeting Pack can be purchased by A1 Business Participant or A2 Second Business Participant only. Please register, login and click again, or go to Pricing Page and buy the A3 Additional Meeting Pack."
            : "Please log in to add items to the cart.",
        showCancelButton: true,
        confirmButtonText: "Log In",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login", { state: { from: "/pricelist" } });
        }
      });
      return;
    }

    const items = selectedItems[category] || [];

    // If specific item is passed (like for "A3")
    if (item) {
      items.push({
        subcategory: item.id,
        price: parseInt(item.price.replace(/[^0-9]/g, "")),
        description: item.title,
        quantity: 1, // Assuming 1 as default for the A3 package
      });
    }

    Swal.fire({
      title: "Item Added to Cart",
      text: "You can add more items or go to the cart and check out.",
      icon: "success",
      confirmButtonText: "OK",
    });

    for (let item of items) {
      await addToCart({
        category,
        subcategory: item.subcategory,
        price: item.price,
        description: item.description,
        quantity: item.quantity || 1,
      });
    }
  };
  const categories = [
    {
      cate: (
        <>
          <span style={{ fontWeight: "bold" }}>A1. Prime Contractor/ OEM</span>
          <span style={{ color: "blue" }}> (Rs 40,000)</span>
          <br />
          Entry fee to DEFENCE PARTNERSHIP DAYS 2026 for one person with benefit
          of fixing 10 pre-scheduled meetings over two days. This Plan includes
          -
          <br />
          • Your company profile page with products, services, presentation,
          brochures & video on the event website
          <br /> • Your participation with contact details(6 lines) published in
          the Event Guide.
          <br /> • Your pre-programmed and individual meeting schedule with
          selected confirmed participants
          <br /> • Free access to Central Talks, Presentations, Parallel
          Programme, Refreshments and Networking Lunch
        </>
      ),
      title: "You are registering as Prime Contractor/ OEM",
      eventId: "1",
      roles: "Prime Contractors/OEMs",
      info: "Prime Contractor/ OEM",
    },
    {
      cate: (
        <>
          <span style={{ fontWeight: "bold" }}>A1. Manufacturer/ Supplier</span>
          <span style={{ color: "blue" }}> (Rs 40,000)</span>
          <br />
          Entry fee to DEFENCE PARTNERSHIP DAYS 2026 for one person with benefit
          of fixing 10 pre-scheduled meetings over two days. This Plan includes
          -
          <br />
          • Your company profile page with products, services, presentation,
          brochures & video on the event website
          <br />
          • Your participation with contact details(6 lines) published in the
          Event Guide.
          <br />
          • Your pre-programmed and individual meeting schedule with selected
          confirmed participants
          <br />• Free access to Central Talks, Presentations, Parallel
          Programme, Refreshments and Networking Lunch
        </>
      ),
      title: "You are registering as Manufacturer/ Supplier",
      eventId: "2",
      roles: "Manufacturers & Suppliers",
      info: "Manufacturer/ Supplier",
    },
    {
      cate: (
        <>
          <span style={{ fontWeight: "bold" }}>
            A2. Second Business Participant with 10-meeting Pack
          </span>
          <span style={{ color: "blue" }}> (Rs. 30,000)</span> <br />
          with all privileges as first participant. Use A1 after 1st Participant
          has registered with (Existing) Company with exact same name while
          registering.
        </>
      ),
      title: "You are registering as Second Business Participant",
      eventId: "7",
      roles: "Second Business Participant",
      info: "Second Business Participant",
    },
    {
      cate: (
        <>
          <span style={{ fontWeight: "bold" }}>
            A3. Additional Meeting Pack
          </span>{" "}
          <span style={{ color: "blue" }}> (Rs 25,000)</span>{" "}
          <span
            style={{ color: "blue" }}
            className=" text-textblue rounded-full py-1 px-3 ml-4 ring-1 ring-textblue "
          >
            Buy Now
          </span>
          <br />
          of 10 additional meetings
        </>
      ),
      title: "You are registering as Event Partner/ Associate/ Media Partner",
      eventId: "8",
      roles: "Event Partners",
      info: "Associate/ Media Partner",
    },
    {
      cate: (
        <>
          <span style={{ fontWeight: "bold" }}>A5. Start-ups</span>
          <span style={{ color: "blue" }}> (Rs. 30,000)</span>
          <br />
          All benefits of A1. Includes 10 meeting pack. For startups with DIPP/
          DPIIT registration number.
        </>
      ),
      title: "You are registering as Start-ups",
      eventId: "4",
      roles: "Start-ups",
      info: "Start-ups",
    },
    {
      cate: (
        <>
          <span style={{ fontWeight: "bold" }}>A6. Casual Visitor</span>{" "}
          <span style={{ color: "blue" }}> (Rs. 7,500)</span>
          <br />
          a. Attend, central talks, flash presentations.
          <br />
          b. Visit exhibition stands.
          <br />
          c. Fix casual meetings with participants who are free at their
          exhibition stands d. Refreshments and lunch are included.
        </>
      ),
      title: "You are registering as Casual Visitor",
      eventId: "6",
      roles: "Casual Visitors",
      info: "Casual Visitor",
    },
    {
      cate: (
        <>
          Key Govt/ Services Officer{" "}
          <span style={{ color: "blue" }}> (Free)</span>
        </>
      ),
      title: "You are registering as Key Govt/ Services Officer",
      eventId: "3",
      roles: "Key Govt/ Services Officer",
      info: "Key Govt/ Services Officers",
    },
    {
      cate: (
        <>
          Investor <span style={{ color: "blue" }}> (Rs. 40,000)</span>
          <br />
          Same benefits as A1
        </>
      ),
      title: "You are registering as Investor",
      eventId: "5",
      roles: "Investors",
      info: "Investors",
    },
  ];

  return (
    <section
      id="register-content"
      className="relative bg-white flex justify-center font-poppins"
    >
      <div className="container 3xl:w-[70%] px-4 lg:px-0 xl:px-20">
        <div className="flex flex-col md:flex-row w-full h-auto mx-auto">
          <div className="mainregister w-full md:w-[38%] lg:w-[30%] py-8 ">
            <div className="relative my-4">
              <h2 className="uppercase text-xl sm:text-xl md:text-3xl lg:text-4xl xl:text-5xl font-bold pb-[0.35rem]">
                {string.registertitle}
              </h2>
              <div className="absolute bottom-0 w-8 md:w-10 lg:w-12 xl:w-16 h-[0.17rem] bg-[#1189CC] rounded-[20px]"></div>
            </div>
            <div className=" flex flex-col gap-4 lg:gap-12">
              <div className="text-justify pb-4 lg:pb-8 text-sm md:text-base lg:text-lg xl:text-xl">
                {string.registertext}
              </div>
              <div className="steps pb-4 lg:pb-8">
                <div className="font-bold py-4 text-sm md:text-base lg:text-lg xl:text-xl">
                  Benefit from:
                </div>
                <ul className="list-disc pl-4 text-sm md:text-base lg:text-lg xl:text-xl">
                  <li className="marker:text-listcolor">{string.regi1}</li>
                  <li className="marker:text-listcolor">{string.regi2}</li>
                  <li className="marker:text-listcolor">{string.regi3}</li>
                </ul>
              </div>
              <div className="text-justify text-sm md:text-base lg:text-lg xl:text-xl">
                {string.registertext2}
              </div>
            </div>
          </div>
          <div className="categoryselection flex w-full md:w-[63%] lg:w-[70%] py-20 md:pl-8 md:pr-4 lg:px-12 xl:pl-20 xl:pr-4">
            <div className="flex flex-col gap-4 xl:gap-8 w-full">
              <div className="relative">
                <h2 className="text-base lg:text-xl xl:text-2xl font-semibold">
                  {string.selectcetegorytitle}
                </h2>
                <div className="absolute bottom-0 w-4 md:w-8 lg:w-8 xl:w-12 h-[0.15rem] bg-[#1189CC] rounded-[20px]"></div>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="relative radiobutton grid grid-cols-1 md:grid-cols-2 gap-2 text-pretty text-sm lg:text-lg">
                  {categories.map((category) => (
                    <div
                      key={category.eventId}
                      className={`flex shadow-md p-3 items-start gap-2 mb-4 ${category.eventId === "8" ? "ml-[20px]" : ""}`}
                    >
                      <input
                        type="radio"
                        className={`radio-large w-[5%] ${category.eventId === "8" ? "hidden" : ""}`}
                        value={category.eventId}
                        checked={selectedCategory === category.eventId}
                        onChange={handleChange}
                        disabled={
                          disableOtherOptions &&
                          selectedCategory !== category.eventId
                        }
                      />
                      <div
                        className={`${category.eventId === "8" ? "pl-0 w-full" : "pl-1 w-[95%]"} text-sm text-justify leading-relaxed`}
                      >
                        <div>
                          {category.eventId === "8" ? (
                            <>
                              <span style={{ fontWeight: "bold" }}>
                                A3. Additional Meeting Pack
                              </span>{" "}
                              <span style={{ color: "blue" }}>(Rs 25,000)</span>{" "}
                              {/* This mimics your pricelist page's button function */}
                              <span
                                className="text-textblue rounded-full py-1 px-3 ring-1 ring-textblue"
                                style={{ color: "blue", cursor: "pointer" }}
                                onClick={(e) => {
                                  e.stopPropagation();

                                  // 1. Find the exact handler your pricelist component uses.
                                  // It is typically called handleAddToCart or handleAddPackage.
                                  // 2. We pass the matching A3 item payload structure your system expects:
                                  const a3Item = {
                                    id: "A3",
                                    title:
                                      "A3. ADDITIONAL MEETING PACK (10 addl meetings)",
                                    buttonText: "Buy Now",
                                  };

                                  // Fire your pre-existing item function to pop open the modal!
                                  handleAddToCart(a3Item);
                                }}
                              >
                                Buy Now
                              </span>
                              <br />
                              of 10 additional meetings
                            </>
                          ) : (
                            category.cate
                          )}

                          <img
                            src={info}
                            onClick={() => handlePopup(category.info)}
                            className="ml-2 inline w-[15px] h-[15px] cursor-pointer hidden"
                            alt="info_icon"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="flex gap-4 mt-4">
                  <button
                    className={`rounded-md font-normal border-[1px] py-2 px-10 ${
                      goClicked
                        ? "bg-gray-500 text-white cursor-not-allowed border-gray-500 "
                        : "bg-textblue text-white border-textblue "
                    }`}
                    type="submit"
                  >
                    Go
                  </button>
                  <button
                    className={`rounded-md font-normal border-[1px]  py-2 px-10 ${
                      goClicked
                        ? "bg-textblue text-white border-textblue"
                        : "bg-gray-500  text-white cursor-not-allowed border-gray-500"
                    }`}
                    type="button"
                    onClick={resetFormState}
                  >
                    Reset
                  </button>
                </div>
              </form>
              <div ref={formRef}>{renderComponent()}</div>
            </div>
          </div>
        </div>
      </div>
      {popup && (
        <PopupContent content={popupContent} onClose={() => setPopup(false)} />
      )}
    </section>
  );
};

export default Register;
